import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=8ef7dbd0&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=8ef7dbd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef7dbd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ef7dbd0')) {
      api.createRecord('8ef7dbd0', component.options)
    } else {
      api.reload('8ef7dbd0', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=8ef7dbd0&scoped=true&", function () {
      api.rerender('8ef7dbd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/platform-sales-fee/modules/table-list/detail.vue"
export default component.exports